import React from 'react'
import { withTranslation } from 'react-i18next';
import moment from 'moment'

const Eier = (props) => {
    var eier = props.eier;
    var fodt = moment.utc(eier.fodt*1000).format("DD.MM.YYYY")
    return(
        <li className="resultitem" onClick={() => props.onSelectResult(eier)}>
            <div className="title">{eier.fornavn}{eier.etternavn && ' '+eier.etternavn} ({props.t('eier')}){fodt ? ` -  ${fodt}` : null}</div>
            <div>{props.t('kommune')}: {eier.kommunenavn} {eier.kommunenummer}</div>
            <div>{eier.personstatus}</div>
        </li>
    )
  }

export default withTranslation('common')(Eier)